import React from 'react';
import Nav from './Nav';
import coverImg from '../../imgs/AboutMe/cover.jpg';

const AboutMe = () => (
  <div>
    <Nav />
    <div className="aboutMe">
      <h2>about me</h2>
      <img className="img-responsive img-centered" src={coverImg} alt="" />
      <p className="content-p">
        Hi there, I am Yufeng. I go by Ritz. I am a product designer, UX
        enthusiast, and advocate.
      </p>
      <p className="content-p">
        {`I love learning others’ stories. I strive to design accessible products that deliver engaging and delightful experiences.`}
      </p>
      <p className="content-p">
        Growing up I always enjoyed creating and designing random things that
        came to my head and wanted to make it my profession. I believe that
        design is not only how something looks but how something works.
      </p>
      <p className="content-p">
        I am a travel aficionado. During my undergrad, I traveled extensively
        across three continents. My curiosity to understand different cultures
        and traditions drive me to continue exploring the world.
      </p>
      <p className="content-p">
        i like hiking when it’s warm and snowboarding when{' '}
        <i>WINTER IS COMING</i> ;). i also enjoy creating things in my spare
        time - painting, cooking, taking photos and making videos.
      </p>
      <p className="content-p">
        don’t hesitate to get in touch with me at{' '}
        <a className="link link--s" href="mailto:ritz@gatech.edu">
          ritz@gatech.edu
        </a>{' '}
        or on{' '}
        <a
          className="link link--s"
          href="https://www.linkedin.com/in/yufengritz"
        >
          LinkedIn
        </a>
      </p>
    </div>
  </div>
);

export default AboutMe;



// WEBPACK FOOTER //
// ./src/Modules/AboutMe/AboutMe.js